import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import cx from "classnames";

import { Logo } from "~/components/common/Logo/Logo";
import { Typography } from "~/ui-kit/components/Typography/Typography";

import "./Footer.scss";

type FooterLinksProps = {
  imprintUrl?: string;
  privacyPolicyUrl?: string;
};

const FooterLinks: FC<FooterLinksProps> = ({
  imprintUrl,
  privacyPolicyUrl,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {imprintUrl ? (
        <Typography
          size={"sm"}
          weight={"md"}
          className="grey-400-c me-4 cursor-pointer"
          onClick={() => window.open(imprintUrl)}
        >
          {t("backend:imprint")}
        </Typography>
      ) : null}
      {privacyPolicyUrl ? (
        <Typography
          size={"sm"}
          weight={"md"}
          className="grey-400-c cursor-pointer"
          onClick={() => window.open(privacyPolicyUrl)}
        >
          {t("backend:privacy_policy")}
        </Typography>
      ) : null}
    </>
  );
};

export const Footer: FC = () => {
  const { t } = useTranslation();
  const imprintUrl = t("backend:imprint_url");
  const privacyPolicyUrl = t("backend:privacy_policy_url");
  const hasAtLeastOneUrl = imprintUrl || privacyPolicyUrl;
  return (
    <div
      className={cx("footer-wrapper container-fluid", {
        "footer-wrapper-mobile-height": hasAtLeastOneUrl,
      })}
    >
      <div className="row h-100">
        {/* Desktop footer links section */}
        <div className="d-none d-md-flex col-md-4 align-items-center">
          <FooterLinks
            imprintUrl={imprintUrl}
            privacyPolicyUrl={privacyPolicyUrl}
          />
        </div>
        <div className="col-12 col-md-4 d-flex justify-content-center align-items-center">
          <Typography size={"sm"} weight={"rg"} className="grey-400-c me-3">
            {t("powered_by")}
          </Typography>
          <Logo />
        </div>
        {/* Mobile responsive footer links section */}
        {hasAtLeastOneUrl ? (
          <>
            <div className="d-flex d-md-none col-12 justify-content-center align-items-center">
              <FooterLinks
                imprintUrl={imprintUrl}
                privacyPolicyUrl={privacyPolicyUrl}
              />
            </div>
            <div className="d-none d-md-flex col-md-4"></div>
          </>
        ) : null}
      </div>
    </div>
  );
};
